import { PlayCircleIcon } from '@langchain/untitled-ui-icons';

import { Link } from 'react-router-dom';

import { IconButton } from '@/design-system';
import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

export const StudioIconButton = ({
  hostProjectId,
  assistantId,
  threadId,
}: {
  hostProjectId: string;
  assistantId?: string;
  threadId?: string;
}) => {
  const organizationId = useOrganizationId();
  return (
    <Link
      to={addQueryParams('/studio', {
        assistantId,
        threadId,
        hostProjectId,
        organizationId,
      })}
    >
      <IconButton
        icon={PlayCircleIcon}
        label="Open deployment in Studio"
        variant="plain"
        color="secondary"
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Link>
  );
};
